import React from 'react';
import { ListRestart, PanelTopOpen, X } from 'lucide-react';

const TRIGGER_LABELS = {
  CANCEL: '일정이 취소되어 대체 후보를 찾았습니다',
  OPPOSE_TIME: '다른 시간대 후보를 찾았습니다',
  OPPOSE_PLACE: '다른 장소 후보를 찾았습니다',
};

const candidateLabel = candidate => {
  const attributes = candidate?.attributes || {};
  if (attributes.startTime) {
    const time = `${attributes.startTime}${attributes.endTime ? `~${attributes.endTime}` : ''}`;
    return `${attributes.date || ''} ${time}`.trim();
  }
  return attributes.name || attributes.address || '대체 후보';
};

const styles = {
  section: {
    borderRadius: '12px',
    border: '1px solid #f59e0b',
    backgroundColor: '#fffbeb',
    padding: '12px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
  },
  title: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#92400e',
    margin: 0,
  },
  list: {
    marginTop: '8px',
    listStyle: 'none',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    fontSize: '12px',
    color: '#78350f',
    backgroundColor: '#fef3c7',
    borderRadius: '6px',
    padding: '4px 8px',
  },
  score: {
    flexShrink: 0,
    fontWeight: '600',
    color: '#b45309',
  },
  dismissBtn: {
    flexShrink: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: '4px',
    borderRadius: '4px',
    color: '#b45309',
    display: 'flex',
    alignItems: 'center',
  },
  openBtn: {
    marginTop: '10px',
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    borderRadius: '8px',
    backgroundColor: '#b45309',
    border: 'none',
    padding: '8px 12px',
    fontSize: '13px',
    fontWeight: '700',
    color: '#ffffff',
    cursor: 'pointer',
  },
};

const CascadeProposedBanner = ({ proposal, onOpen, onDismiss }) => {
  const alternatives = (proposal?.cascadeResult?.alternatives || []).slice(0, 3);
  if (alternatives.length === 0) return null;

  return (
    <section style={styles.section} aria-live="polite">
      <div style={styles.header}>
        <ListRestart size={18} style={{ marginTop: '2px', flexShrink: 0, color: '#b45309' }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={styles.title}>
            {TRIGGER_LABELS[proposal.triggerAction] || '일정 변경에 맞는 대체 후보를 찾았습니다'}
          </p>
          <ol style={styles.list}>
            {alternatives.map((candidate, index) => (
              <li key={candidate.candidateId || index} style={styles.listItem}>
                <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {index + 1}. {candidateLabel(candidate)}
                </span>
                <span style={styles.score}>
                  {Math.round((candidate.score ?? 0) * 100)}%
                </span>
              </li>
            ))}
          </ol>
        </div>
        <button
          type="button"
          onClick={onDismiss}
          style={styles.dismissBtn}
          title="닫기"
          aria-label="대체 후보 알림 닫기"
        >
          <X size={16} />
        </button>
      </div>
      <button
        type="button"
        onClick={onOpen}
        style={styles.openBtn}
      >
        <PanelTopOpen size={16} />
        대체 후보 보기
      </button>
    </section>
  );
};

export default CascadeProposedBanner;
